import type { PartialMessage } from '@bufbuild/protobuf';

import type { SetToothFullHeadMPRSliceAnnotationsReq } from '@/shared/api/protocol-ts/api/core/svc_report_pb';

import {
  SERIES_TO_ORIENTATION,
  type FullHeadMprSliceTileView,
} from '../config';

export const makeFullHeadMprSliceTarget = ({
  tile,
  toothID,
  sliceStepMm,
}: {
  tile: FullHeadMprSliceTileView;
  toothID: string;
  sliceStepMm: number;
}): Pick<
  PartialMessage<SetToothFullHeadMPRSliceAnnotationsReq>,
  'ToothID' | 'Target'
> => ({
  ToothID: toothID,
  Target:
    tile.kind === 'view'
      ? { case: 'SliceID', value: tile.recordID }
      : {
          case: 'Series',
          value: {
            Orientation: SERIES_TO_ORIENTATION[tile.seriesName],
            OffsetMm: tile.offsetMm,
            SliceStepMm: sliceStepMm,
          },
        },
});
